class MeshObjectCreator {
    create(geometry, material) {
        throw new Error("Method .create is not implemented");
    }

    dispose(object) {
        throw new Error("Method .dispose is not implemented");
    }

    setGeometry(object, geometry) {
        throw new Error("Method .setGeometry is not implemented");
    }

    setMaterial(object, material) {
        throw new Error("Method .setMaterial is not implemented");
    }
}

export default MeshObjectCreator;
